import { Constant } from '@configs/index';
import { useOpenRequestList } from '@hooks/Services';
import React from 'react';
import styled from 'styled-components';
import { CreateSearchParams, Error, Loading, ShowNumber } from '../index';

const OpenError = () => {
    const searchParams = CreateSearchParams.Open(Constant.DASHBOARD_SEARCH_CONDITIONS.OPEN_ERROR_RENT);
    const { data, error, loading } = useOpenRequestList.useAllListData(searchParams);
    const totalCount = data?.length || 0;
    return (
        <WrapperWithStyled>
            <LabelWithStyled>不備</LabelWithStyled>
            <Loading loading={loading} />
            {error && <Error />}
            {!loading && !error &&
                <ShowNumber totalCount={totalCount} />
            }
        </WrapperWithStyled>
    );
};
const WrapperWithStyled = styled.div`
    position: relative;
    padding: 0 10px 10px;
    text-align: right;
`
const LabelWithStyled = styled.span`
    font-size: 18px;
    float: left;
    display: inline-block;
    margin-top: 18px;
`

export default OpenError;